import { Link } from "@tanstack/react-router";
import { AlertCircle, Home } from "lucide-react";

import { Button } from "@pbz/ui-kit";

import { HOME_ROUTE } from "@/utils/constants";

const NotFound = () => {
  return (
    <div className="flex flex-col items-center justify-center min-h-[80vh] text-center px-4">
      <div className="mb-6">
        <AlertCircle className="h-16 w-16 text-red-500 mx-auto" />
      </div>
      <h1 className="text-3xl font-bold mb-2">Page Not Found</h1>
      <p className="text-gray-600 mb-8 max-w-md">
        The page you are looking for doesn't exist or you don't have permission
        to access it.
      </p>
      <Link to={HOME_ROUTE}>
        <Button className="flex items-center gap-2">
          <Home className="h-4 w-4" />
          Back to Lead List
        </Button>
      </Link>
    </div>
  );
};

export default NotFound;
